
/**
 * 获取入住时长
 * @param {String} start 开始时间
 * @param {String} end 结束时间
 * @param {Number} type 入住类型：1-全日房；2-钟点房
 */
 export const getStayLength = (start, end, type) => {
  let stayCount = 1
  if (start && end) {
    let sTime = +(new Date(start))
    let eTime = +(new Date(end))
    if (type == 1) {
      stayCount = Math.round((eTime - sTime) / (24 * 60 * 60 * 1000))
    } else {
      stayCount = Math.round((eTime - sTime) / (60 * 60 * 1000))
    }
  }
  stayCount = (stayCount === 0 ? 1 : stayCount)

  return stayCount
}